import React, { useState } from 'react'
import { Button, Modal, Form } from 'react-bootstrap'

const AddShipping = ({ childToparent }) => {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [shipping, setShipping] = useState(0)

  const addShipping = (e) => {
    e.preventDefault()
    childToparent(shipping)
    return handleClose()
  }

  return (
    <div>
      <Button variant='info' size='sm' onClick={handleShow}>
        Add Shipping
      </Button>
      <Modal show={show}>
        <Modal.Header closeButton>
          <Modal.Title>Add Shipping</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={addShipping}>
            <Form.Group controlId='shipping'>
              <Form.Label>Shipping Cost</Form.Label>
              <Form.Control
                type='number'
                min='0.00'
                step='0.01'
                value={shipping}
                placeholder='Enter shipping cost'
                onChange={(e) => setShipping(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
          <Button variant='primary' onClick={addShipping}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default AddShipping
